(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-benifit-table"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const animateItems = document.querySelectorAll('.trade-benefits-section .animate-item');
    
    if (animateItems.length) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('revealed');
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.1,
        rootMargin: '0px 0px -30px 0px'
      });
      
      animateItems.forEach(item => {
        observer.observe(item);
      });
    }
    
    // Fallback for already visible items
    const alreadyVisible = document.querySelectorAll('.animate-item:not(.revealed)');
    if (alreadyVisible.length) {
      const checkVisibility = () => {
        alreadyVisible.forEach(el => {
          const rect = el.getBoundingClientRect();
          const windowHeight = window.innerHeight;
          if (rect.top < windowHeight - 80) {
            el.classList.add('revealed');
          }
        });
      };
      checkVisibility();
      window.addEventListener('scroll', checkVisibility);
      window.addEventListener('resize', checkVisibility);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-collection-list"] && !Shopify.designMode) return;
  try {
    
  (function() {
    // Animation observer
    const animateItems = document.querySelectorAll('.category-section .animate-item');
    
    if (animateItems.length) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('revealed');
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.1,
        rootMargin: '0px 0px -30px 0px'
      });
      
      animateItems.forEach(item => {
        observer.observe(item);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-contact-from"] && !Shopify.designMode) return;
  try {
    
  (function() {
    // Animation observer
    const animateItems = document.querySelectorAll('.contact-page-section .animate-item');
    
    if (animateItems.length) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('revealed');
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.1,
        rootMargin: '0px 0px -30px 0px'
      });
      
      animateItems.forEach(item => {
        observer.observe(item);
      });
    }
    
    // Auto hide messages after 8 seconds
    setTimeout(function() {
      const messages = document.querySelectorAll('.form-message');
      messages.forEach(function(message) {
        if (message.style.display === 'flex' || message.classList.contains('success') || message.classList.contains('error')) {
          setTimeout(function() {
            message.style.opacity = '0';
            setTimeout(function() {
              message.style.display = 'none';
              message.style.opacity = '1';
            }, 300);
          }, 8000);
        }
      });
    }, 100);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-pinter-guide"] && !Shopify.designMode) return;
  try {
    
  (function() {
    // Animation observer
    const animateItems = document.querySelectorAll('.compatibility-section .animate-item');
    
    if (animateItems.length) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('revealed');
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.1,
        rootMargin: '0px 0px -30px 0px'
      });
      
      animateItems.forEach(item => {
        observer.observe(item);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-request-form"] && !Shopify.designMode) return;
  try {
    
  (function() {
    // Animation observer
    const animateItems = document.querySelectorAll('.sample-form-section .animate-item');
    
    if (animateItems.length) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('revealed');
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.1,
        rootMargin: '0px 0px -30px 0px'
      });
      
      animateItems.forEach(item => {
        observer.observe(item);
      });
    }
    
    // Auto hide messages after 8 seconds
    setTimeout(function() {
      const messages = document.querySelectorAll('.form-message');
      messages.forEach(function(message) {
        if (message.style.display === 'flex' || message.classList.contains('success') || message.classList.contains('error')) {
          setTimeout(function() {
            message.style.opacity = '0';
            setTimeout(function() {
              message.style.display = 'none';
              message.style.opacity = '1';
            }, 300);
          }, 8000);
        }
      });
    }, 100);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-trade-form"] && !Shopify.designMode) return;
  try {
    
  (function() {
    // Animation observer
    const animateItems = document.querySelectorAll('.trade-form-section .animate-item');
    
    if (animateItems.length) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('revealed');
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.1,
        rootMargin: '0px 0px -30px 0px'
      });
      
      animateItems.forEach(item => {
        observer.observe(item);
      });
    }
    
    // Auto hide messages after 8 seconds
    setTimeout(function() {
      const messages = document.querySelectorAll('.form-message');
      messages.forEach(function(message) {
        if (message.style.display === 'flex' || message.classList.contains('success') || message.classList.contains('error')) {
          setTimeout(function() {
            message.style.opacity = '0';
            setTimeout(function() {
              message.style.display = 'none';
              message.style.opacity = '1';
            }, 300);
          }, 8000);
        }
      });
    }, 100);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-value-proposition"] && !Shopify.designMode) return;
  try {
    
  (function() {
    // Smooth scroll + Intersection Observer for smooth reveal animations
    const animateElements = document.querySelectorAll('.value-prop-left.animate-item, .stat-card.animate-item');
    
    if (animateElements.length) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('revealed');
            // Unobserve after reveal for better performance
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.15,
        rootMargin: '0px 0px -20px 0px'
      });
      
      animateElements.forEach(el => {
        observer.observe(el);
      });
    }
    
    // Fallback: check if any element is already visible on load
    const alreadyVisible = document.querySelectorAll('.animate-item:not(.revealed)');
    if (alreadyVisible.length) {
      const checkVisibility = () => {
        alreadyVisible.forEach(el => {
          const rect = el.getBoundingClientRect();
          const windowHeight = window.innerHeight;
          if (rect.top < windowHeight - 100) {
            el.classList.add('revealed');
          }
        });
      };
      checkVisibility();
      window.addEventListener('scroll', checkVisibility);
      window.addEventListener('resize', checkVisibility);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
